import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-settings-row',
  templateUrl: './settings-row.component.html',
  styleUrls: ['./settings-row.component.scss']
})
export class SettingsRowComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
